<template>
  <v-container fluid class="purchaseorder-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="12" lg="12" class="d-flex flex-start justify-md-start overflow-auto">
              <v-btn to="/purchaseorder/add" color="success" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn color="success" class="button-shadow mr-2" @click="findSalesOrderDialog=true">
                <v-icon class="mr-2">mdi-file-search</v-icon>
                Find
              </v-btn>
              <v-btn color="primary" class="button-shadow mr-3" @click="makePaymentList">
                <v-icon class="mr-2">mdi-cash-plus</v-icon>
                Pay
              </v-btn>
              <!-- <v-btn color="primary" class="button-shadow mr-2" @click="makePurchaseReceipt">
                <v-icon class="mr-2">mdi-invoice-arrow-left-outline</v-icon>
                Receive
              </v-btn> -->
              <v-btn to="/batchpayment/list" color="default" class="button-shadow mr-2">
                <v-icon class="mr-2">mdi-file-multiple</v-icon>
                Payments
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="purchaseorders-table"
              show-select
              single-select
              v-model="data_selected"
              item-key="_id"
              :footer-props="footer"
              :headers="headers"
              :items="purchaseorders"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Purchase Order?
                    </v-card-title>
                    <v-card-text>
                      {{ deletepurchaseorder.purchaseordernum }} 
                      {{ deletepurchaseorder.purchaseordername }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteItem(deletepurchaseorder)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.userid="{ item }">
                <div v-if="item.userid!=undefined">
                  <p class="two-line">
                    <v-avatar v-if="users.length>0 && users.find(user=>user._id == item.userid)['userimage']!==''" size="40">
                      <img v-bind:src="users.find(user=>user._id == item.userid)['userimage']" alt="">
                    </v-avatar>
                    <v-avatar
                      v-else
                      color="warning"
                      size="40">
                      <span class="white--text headline">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'][0].toUpperCase() : '' }}</span>
                    </v-avatar>
                  </p>
                  <p class="two-line">
                    <span style="margin-left:0px; font-size: 9pt;">{{ users.length>0 ? users.find(user=>user._id == item.userid)['username'] : '' }} </span>
                  </p>
                </div>
              </template>
              <template v-slot:item.purchaseorderimage="{ item }">
                    <v-img
                    v-if="item.purchaseorderimage" 
                    v-bind:src="item.purchaseorderimage"
                    max-height="60"
                    max-width="60"
                  ></v-img>
              </template>
              <template v-slot:item.receipts="{ item }">
                {{ item.receipts.reduce((partial_sum, tran) => parseFloat(partial_sum) + parseFloat(tran.receiveQty),0).toFixed(0) }}
              </template>
              <template v-slot:item.isTaxable="{ item }">
                <v-icon v-if="item.isTaxable==true" size="18" color="blue">mdi-check</v-icon>
              </template>
              <template v-slot:item.purchaseordernum="{ item }">
                <p class="two-line">{{ item.purchaseordertype  }}</p>
                <p class="two-line">{{ item.purchaseordernum  }}</p>
                <p class="two-line">{{ new Date(item.purchaseorderdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}</p>
              </template>
              <template v-slot:item.purchaseorderaddress="{ item }">
                <p class="two-line">{{ item.purchaseorderaddress }}</p>
                <p class="two-line">{{ regions.length>0 ? regions.find(region=>region._id == item.regionid)['regionname'] : ''  }} - {{ townships.length>0 ? townships.find(township=>township._id == item.townshipid)['townshipname'] : ''  }}</p>
              </template>
              <template v-slot:item.purchaseordertotal="{ item }">
                <p v-if="item.primaryCurrency" class="two-line"><span style="font-size: x-small;">{{ item.primaryCurrency }}</span> {{ item.purchaseordertotal.toFixed(2).toLocaleString('en-SG') }}</p>
                <p v-if="item.primaryCurrency!=item.secondaryCurrency" class="two-line"><span style="font-size: x-small;">{{ item.secondaryCurrency }}</span> {{ (item.purchaseordertotal * item.currencyRate).toFixed(2).toLocaleString('en-SG') }}</p>
              </template>
              <template v-slot:item.payments="{ item }">
                <div v-if="item.payments">{{ item.payments.map(item=>item.transamount.toFixed(2).toString()).join(', ') }}</div>
                <div v-if="item.payments" style="font-size: 8pt;">{{ item.payments.map(item=>new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })).join(', ') }}</div>
              </template>
              <template v-slot:item.purchaseorderstatus="{ item }">
                <v-chip
                  :color="
                  item.purchaseorderstatus=='New' ? 'primaryConst white--text' :
                  item.purchaseorderstatus=='Partial' ? 'warning white--text' : 
                  item.purchaseorderstatus=='Completed' ? 'success white--text' : 
                  'secondaryConst white--text'"
                  small
                >
                  {{ item.purchaseorderstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <!-- <v-btn icon color="primary" @click="viewItem(item)">
                  <v-icon>mdi-magnify</v-icon>
                </v-btn> -->
                <v-btn v-if="['New', 'Partial', 'Completed'].indexOf(item.purchaseorderstatus)!=-1" icon color="primary" @click="editItem(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="printItem(item)">
                  <v-icon>mdi-printer</v-icon>
                </v-btn>
                <v-btn v-if="item.purchaseorderstatus=='New'" icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from "../../../config"
import { mapState, mapActions } from 'vuex'

export default {
  name: 'PurchaseOrderList',
  data() {
    return {
      config,
      snackbar: null,
      dialog: false,
      deletepurchaseorder: {},
      headers: [
        { text: 'Order', value: 'purchaseordernum', sortable: false },
        { text: 'Name', value: 'purchaseordername' },
        { text: 'Amount', value: 'purchaseordertotal' },
        { text: 'Paid', value: 'payments', width: "10%" },
        { text: 'Created', value: 'userid', width: '10%' },
        { text: 'Status', value: 'purchaseorderstatus', width: '10%' },
        { text: 'Tax', value: 'isTaxable', width: "2%" },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      itemPerPage: 100,
      selected: [],
      data_selected: [],
    }
  },
  computed: {
    ...mapState('PurchaseOrder', ['purchaseorders', 'isReceiving', 'isDeleting', 'idToDelete', 'purchaseordersMessage', 'isUpdating']),
    ...mapState('Region', ['regions']),
    ...mapState('Township', ['townships']),
    ...mapState('User', ['users']),
  },
  async created () {
    await this.getPurchaseOrdersRequest();
    if(this.regions.length==0) await this.getRegionsRequest();
    if(this.townships.length==0) await this.getTownshipsRequest();
    if(this.users.length==0) await this.getUsersRequest();
  },
  methods: {
    ...mapActions('Region', ["getRegionsRequest"]),
    ...mapActions('Township', ["getTownshipsRequest"]),
    ...mapActions('PurchaseOrder', ["getPurchaseOrdersRequest","deletePurchaseOrderRequest","updatePurchaseOrderRequest","createPurchaseOrderRequest"]),
    ...mapActions('User', ["getUsersRequest"]),
    checkError(){
      if(this.data_selected.length==0) return false;
      if(this.data_selected.find(item=>item.purchaseorder=='Completed')!=null) return false;
      return true;
    },
    checkOrders(){
      return this.data_selected.filter(item=>item.purchaseorderstatus=='Completed').map(item=>item.purchaseordernum.toString()).join(', ');
    },
    editItem(item) {
      this.$router.push({ name: 'PurchaseOrderEdit', params: item })
    },
    getJson(){

    },
    getFileName(){
      var d = new Date();
      var name = 'sales-orders-' + d.getFullYear() + '-' + (d.getMonth()+1).toString() + '-' + d.getDate() + '-' + (d.getHours().toString() +d.getSeconds().toString());
      return name + '.xls';
    },
    printItem(item) {
      this.$router.push({ name: 'PurchaseOrderPrint', params: item })
    },
    viewItem(item) {
      this.$router.push({ name: 'PurchaseOrderView', params: item })
    },
    makePurchaseReceipt(){
      let item = this.data_selected[0];
      if(this.data_selected.length==0) return;
      if(item.purchaseorderstatus=='Completed') return;
      this.$router.push({ name: 'PurchaseReceiptAdd', params: item })
    },
    makePaymentList(){
      if(!this.checkError()) {
        if(this.data_selected.length==0) this.dialogMessage='No Orders selected';
        else this.dialogMessage='The following Orders cannot be paid:  ' + this.checkOrders();
        this.dialogAlert=true; 
        return;
      }
      let orders = Object.assign([], this.data_selected);
      let json = {bills: orders, isOrders: true};
      json['_isFrom'] = this.$route.name;
      this.$router.push({ name: 'BatchPaymentAdd', params: json });
    },
    deleteItem(item) {
      this.deletePurchaseOrderRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletepurchaseorder = {
        _id: item._id,
        purchaseordernum: item.purchaseordernum,
        purchaseordername: item.purchaseordername,
      }
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
